export default __webpack_public_path__ + "static/media/David.40fab393.jpg";